import VueRouter from "vue-router";
import Index from './components/index';
import loginComponent from './components/Auth/login';
import signUpcomponent from './components/Auth/signup';
import verifyEmailComponent from './components/Auth/verifyEmail';
import forgetPasswordComponent from './components/Auth/forgetPassword';
import resetPasswordComponent from './components/Auth/resetPassword';

import faqsComponent from './components/faqs';
import termsAndConditions from './components/terms-and-conditions';
import corporateContracts from './components/contracts';


import orderComponent from './components/order';
import cartComponent from './components/cart';


import myOrdersComponent from './components/accounts/my-orders';
import accountProfileComponent from './components/accounts/my-profile';
import orderDetailsComponent from './components/accounts/order-details';
import walletsComponent from './components/accounts/my-wallets';
import addUpdateWalletComponent from './components/accounts/addUpdateWallet';



import adminDashboardComponent from './components/admin/dashboard';
import adminProfileComponent from './components/admin/admin-profile';

import adminOrdersComponent from'./components/admin/adminOrders';
import adminOrderDetailsComponent from './components/admin/adminOrderDetails';
import adminFaqsComponent from'./components/admin/listFaqs';
import adminAddFaqsComponent from'./components/admin/addUpdateFaqs';
import adminGeneralSettingsComponent from'./components/admin/generalSettings';
import adminaddUpdateSettingsomponent from'./components/admin/addUpdateSettings';
import adminscheduleDeliveryComponent from'./components/admin/scheduleDelivery';

import privacyPolicy from './components/privacy-policy';


import testPlaces from './components/testPlaces'

import fb from './components/facebook';

import { isLoggedIn, isloginAdmin } from "./utils/auth";
const routes = [
    {
        path: "/",
        name: "home",
        component: Index,
        meta: {
            NoLoginRequired: false,
        }
    },
    {
        path: "/signup",
        name: "signup",
        component: signUpcomponent,
        meta: {
            NoLoginRequired: false,
        }
    },
    {
        path: "/terms-and-conditions",
        name: "terms-and-conditions",
        component: termsAndConditions,
        meta: {
            NoLoginRequired: false,
        }
    },
    {
        path: "/corporate-contracts",
        name: "corporate-contracts",
        component: corporateContracts,
        meta: {
            NoLoginRequired: false,
        }
    },
    {
        path: "/fb",
        name: "fb",
        component: fb,
        meta: {
            NoLoginRequired: false,
        }
    },
    {
        path: "/privacy-policy",
        name: "privacy-policy",
        component: privacyPolicy,
        meta: {
            NoLoginRequired: false,
        }
    },
    {
        path: '/google-success',
        component: {
            template: '<div class="auth-component"></div>'
        }
    },
    {
        path: "/login",
        name: "login",
        component: loginComponent,
        meta: {
            NoLoginRequired: false,
        }
    },
    {
        path: "/verify-email-address/:id",
        name: "verify-email-address",
        component: verifyEmailComponent,
        meta: {
            NoLoginRequired: false,
        }
    },

    {
        path: "/forget-password",
        name: "forget-password",
        component: forgetPasswordComponent,
        meta: {
            NoLoginRequired: false,
        }
    },
    {
        path: "/forget-password-reset/:id",
        name: "forget-password-reset",
        component: resetPasswordComponent,
        meta: {
            NoLoginRequired: false,
        }
    },
    {
        path: "/faqs",
        name: "faqs",
        component: faqsComponent,
        meta: {
            NoLoginRequired: false,
        }
    },
    {
        path: "/order",
        name: "order",
        component: orderComponent,
        meta: {
            NoLoginRequired: false,
            UserLoginRequired: true,
            AdminLoginRequired: false
        }
    },
    {
        path: "/cart",
        name: "cart",
        component: cartComponent,
        meta: {
            NoLoginRequired: false,
            UserLoginRequired: true,
            AdminLoginRequired: false
        }
    },

    {
        path: "/my-orders",
        name: "my-orders",
        component: myOrdersComponent,
        meta: {
            NoLoginRequired: false,
            UserLoginRequired: true,
            AdminLoginRequired: false
        }
    },
    {
        path: "/account-profile",
        name: "account-profile",
        component: accountProfileComponent,
        meta: {
            NoLoginRequired: false,
            UserLoginRequired: true,
            AdminLoginRequired: false
        }
    },
    {
        path: "/order-details/:id/:type",
        name: "order-details",
        component: orderDetailsComponent,
        meta: {
            NoLoginRequired: false,
            UserLoginRequired: true,
            AdminLoginRequired: false
        }
    },
    {
        path: "/customer-wallets",
        name: "customer-wallets",
        component: walletsComponent,
        meta: {
            NoLoginRequired: false,
            UserLoginRequired: true,
            AdminLoginRequired: false
        }
    },
    {
        path: "/add-wallet",
        name: "add-wallet",
        component: addUpdateWalletComponent,
        meta: {
            NoLoginRequired: false,
            UserLoginRequired: true,
            AdminLoginRequired: false
        }
    },
    
    


    {
        path: "/admin-dashboard",
        name: "admin-dashboard",
        component: adminDashboardComponent,
        meta: {
            NoLoginRequired: false,
            UserLoginRequired: false,
            AdminLoginRequired: true
        }
    },
    {
        path: "/admin-profile",
        name: "admin-profile",
        component: adminProfileComponent,
        meta: {
            NoLoginRequired: false,
            UserLoginRequired: false,
            AdminLoginRequired: true
        }
    },

    {
        path: "/admin-orders",
        name: "admin-orders",
        component: adminOrdersComponent,
        meta: {
            NoLoginRequired: false,
            UserLoginRequired: false,
            AdminLoginRequired: true
        }
    },
    {
        path: "/admin/order-details/:id/:type",
        name: "admin-order-details",
        component: adminOrderDetailsComponent,
        meta: {
            NoLoginRequired: false,
            UserLoginRequired: true,
            AdminLoginRequired: false
        }
    },

    {
        path: "/admin/faqs",
        name: "admin-faqs",
        component: adminFaqsComponent,
        meta: {
            NoLoginRequired: false,
            UserLoginRequired: false,
            AdminLoginRequired: true
        }
    },

    {
        path: "/admin/add-faq",
        name: "admin-add-faq",
        component: adminAddFaqsComponent,
        meta: {
            NoLoginRequired: false,
            UserLoginRequired: false,
            AdminLoginRequired: true
        }
    },
    {
        path: "/admin/update-faq/:id",
        name: "admin-update-faq",
        component: adminAddFaqsComponent,
        meta: {
            NoLoginRequired: false,
            UserLoginRequired: false,
            AdminLoginRequired: true
        }
    },
    {
        path: "/admin/general-settings",
        name: "admin-general-settings",
        component: adminGeneralSettingsComponent,
        meta: {
            NoLoginRequired: false,
            UserLoginRequired: false,
            AdminLoginRequired: true
        }
    },
    {
        path: "/admin/add-setting",
        name: "admin-add-setting",
        component: adminaddUpdateSettingsomponent,
        meta: {
            NoLoginRequired: false,
            UserLoginRequired: false,
            AdminLoginRequired: true
        }
    },
    {
        path: "/admin/update-setting/:id",
        name: "admin-update-setting",
        component: adminaddUpdateSettingsomponent,
        meta: {
            NoLoginRequired: false,
            UserLoginRequired: false,
            AdminLoginRequired: true
        }
    },
    {
        path: "/admin/schedule-delivery",
        name: "admin-schedule",
        component: adminscheduleDeliveryComponent,
        meta: {
            NoLoginRequired: false,
            UserLoginRequired: false,
            AdminLoginRequired: true
        }
    },


    {
        path: "/google-places",
        name: "google-places",
        component: testPlaces,
        meta: {
            NoLoginRequired: false,
            UserLoginRequired: false,
            AdminLoginRequired: true
        }
    },

    {
        path: "*",
        name: "notfound",
        // component: testPlaces,
        meta: {
            NoLoginRequired: true,
            UserLoginRequired: false,
            AdminLoginRequired: false
        }
    },

    // {
    //     path: "/admin/update-seasons/:id",
    //     name: "admin-update-seasons",
    //     component: adminAddUpdateSeasons,
    //     meta: {
    //         NoLoginRequired: false,
    //         UserLoginRequired: false,
    //         AdminLoginRequired: true
    //     }
    // },
];
const router = new VueRouter({
    routes, // short for `routes: routes`
    mode: "history",
    linkActiveClass: "active",
    scrollBehavior() {
        return { x: 0, y: 0 }
    }
});

router.beforeEach((to, from, next) => {
    console.log("isLoggedIn()", isLoggedIn());
    /** CASE@  if user not login and try to access Client dashboaard protected path*/
    if (to.meta.UserLoginRequired && !isLoggedIn() && to.name !== 'home') {
        const logoutError = "Authorization failed. You need to be logged in view this page.";
        router.push({ name: 'login', params: { logoutError: logoutError } });
    } 
    else if (isLoggedIn() && (to.name == 'signup' || to.name == 'login')) {
        const error = "Can't Signup when already loggedIn";
        router.push({ name: 'account-profile', params: { error: error } });
    } 
    else if (to.meta.AdminLoginRequired && !isloginAdmin() && to.name !== 'home') {
        const logoutError = "Authorization failed. You need to be logged in view this page.";
        router.push({ name: 'home', params: { logoutError: logoutError } });
    }
    else if(to.name == 'notfound')
    {
        router.push({ name: 'home' });

    }
     else {
        next();
    }
});
export default router;


// "watch": "watch 'npm run build' ./src",


// WEBPACK FOOTER //
// ./src/routes.js